module.exports = __webpack_public_path__ + "img/cv.b97d8fcd.png";